/** Adding the web app to the Home Screen, so it opens like an app (and on iPhone, gets notifications). */
import { useEffect, useState } from "react";
import { Button, Card } from "./ui";

type InstallPrompt = Event & { prompt: () => Promise<void> };
let installPrompt: InstallPrompt | null = null;
if (typeof window !== "undefined") {
  window.addEventListener("beforeinstallprompt", (event) => {
    event.preventDefault();
    installPrompt = event as InstallPrompt;
  });
}

/** A card offering to add the app to the Home Screen, where the browser can (or how, on iPhone). */
export function InstallHint({ title, why }: { title: string; why: string }) {
  const [available, setAvailable] = useState(Boolean(installPrompt));
  useEffect(() => {
    const listener = () => setAvailable(true);
    window.addEventListener("beforeinstallprompt", listener);
    return () => window.removeEventListener("beforeinstallprompt", listener);
  }, []);
  const ios = /iphone|ipad|ipod/i.test(navigator.userAgent);
  if (!available && !ios) return null;
  return (
    <Card className="install-hint">
      <strong>{title}</strong>
      {available ? (
        <>
          <span>{why}</span>
          <Button
            block={false}
            onClick={async () => {
              await installPrompt?.prompt();
              installPrompt = null;
              setAvailable(false);
            }}
          >
            Add to Home Screen
          </Button>
        </>
      ) : (
        <span>In Safari, tap Share, then Add to Home Screen. {why}</span>
      )}
    </Card>
  );
}
